<template>
  <br />
  <div class="row">
    <div class="col-4">
      <label for="cpf">CPF do Militar</label>
      <div class="input-group input-focus">
        <a-tooltip :visible="tooltipCpf" title="Necessário um cpf válido" placement="top">
          <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" @keyup="validarCpf" v-model="form.cpf" id="cpf" />
        </a-tooltip>
      </div>
    </div>
    <div class="col-sm-1" style="padding-left: 0; width: 4.7%; margin-top: 22px">
      <div class="input-group-prepend">
        <span class="input-group-text bg-white" @click="searchDependente"><i class="fa fa-search"></i></span>
      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col d-flex justify-content-center">
      <label style="text-align: center"> Dependentes do Militar</label>
    </div>
  </div>
  <br />
  <div>
    <a-table :dataSource="dataDependentes" :columns="columns">
      <template #cpf="{ record }">
        <span>{{ formatarCpf(record.cpf) }}</span>
      </template>
      <template #action="{ record }">
        <a v-if="record.possui" @click="editar(true, record)"><i class="fas fa-edit icon-edit"></i></a>
        <a v-if="!record.possui" @click="editar(false, record)"><i class="fas fa-add icon-add"></i></a>
      </template>
    </a-table>
    <br />
  </div>

  <div class="row">
    <div class="col d-flex justify-content-center"><button type="button" class="btn btn-primary" @click="this.$router.push({ path: '/paciente-page' })">Voltar</button>&nbsp;</div>
  </div>
</template>

<script>
import { formatCpf, removeMascaraCpf, validarCpf } from '@/utils/servicos-utils';
import { getDependetesPorCpfMilitar } from '@/config/servicos-utils';
import { getDependentePorCpfMilitarNomeDependente } from '@/components/service/pacienteService';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'PagePacienteDependente',
  data() {
    return {
      naoEncontrado: false,
      form: {
        nome: undefined,
        cpf: undefined,
      },
      dataDependentes: [],
      tooltipCpf: false,
      columns: [
        {
          title: 'Nome Completo',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    goToCreate(type) {
      if (type === 'dependente') {
        this.$router.push('consulta-paciente-' + type);
      } else {
        this.$router.push('form-paciente-' + type);
      }
    },
    voltar() {
      this.$router.push('paciente');
    },
    async searchDependente() {
      var cpfSemMascaraf = removeMascaraCpf(this.form.cpf);
      await getDependetesPorCpfMilitar(cpfSemMascaraf).then(async (r) => {
        for (let depen of r.data) {
          await getDependentePorCpfMilitarNomeDependente({
            nome: depen.nome,
            cpf: removeMascaraCpf(this.form.cpf),
          }).then((r) => {
            if (r.data) {
              depen['idHpm'] = r.data.id;
              depen['possui'] = true;
            }
          });
        }

        this.dataDependentes = r.data;

        if (this.dataDependentes.length === 0) {
          openNotification(typesNotification.info, 'Não foram encontrados dependentes no SICAD para este Paciente');
        }
      });
    },
    formatarCpf(cpf) {
      return formatCpf(cpf);
    },
    validarCpf() {
      let value = this.$refs.cpf.value;
      this.$refs.cpf.classList.value = ['form-control'];
      this.tooltipCpf = false;
      if (value.length > 0 && !validarCpf(value)) {
        this.tooltipCpf = true;
        this.$refs.cpf.classList.value = ['form-control is-invalid'];
      }
    },
    editar(tipo, dependente) {
      if (tipo) {
        this.$router.push({ path: '/form-paciente-dependente/edit', query: { id: dependente.idHpm } });
      } else {
        dependente['cpfDependente'] = this.$refs.cpf.value;
        localStorage.setItem('dependenteMilitar', JSON.stringify(dependente));
        this.$router.push({ path: '/form-paciente-dependente' });
      }
    },
  },
};
</script>

<style scoped>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}
</style>
